import React, { useEffect } from 'react';
import MetricCard from './MetricCard';
import { useStudent } from '../../DataStore/StudentContext';
import functions from '../../util/functions';
import { useStaff } from '../../DataStore/StaffContext';
import { useConfig } from '../../DataStore/ConfigContext';
import RenderSecure from '../../util/RenderSecure';

const MetricSection = () => {

    const {getStudentPopulation, studentPopulation, getStudentAlumniCount, alumniCount} = useStudent();
    const {totalStaff, getTotalStaff} = useStaff();
    const {getSubjectCount, subjectCount} = useConfig();

    useEffect(()=>{
      getStudentPopulation();
      getStudentAlumniCount();
      getTotalStaff();
      getSubjectCount();
    }, []);


    return (
        <>
        <RenderSecure code={['STUDENT_POPULATION', 'STAFF_POPULATION']}>
         <div className="row mb-0 small-gutters">
          {/* Revenue */}
          <RenderSecure code="STAFF_POPULATION">
            <div className="col-md-6 col-lg-6">
              <MetricCard 
                iconClass="fa fa-users"
                iconBg="bg-success"
                title="Student Population"
                value= {studentPopulation?.total_population ? functions.numberFormat(studentPopulation.total_population) : '...'}
                trendText="Total Students"
              />
            </div>
          </RenderSecure>

          {/* Members */}
          <RenderSecure code="STAFF_POPULATION">
            <div className="col-md-6 col-lg-6">
              <MetricCard 
                iconClass="fa fa-user-tie"
                iconBg="bg-primary"
                title="Staff Count"
                value= {totalStaff ? functions.numberFormat(totalStaff) : '...'}
                trendText="Total Staff Members"
              />
            </div>
          </RenderSecure>
          </div>
        </RenderSecure>

        <RenderSecure code ={['SUBJECT_COUNT', 'STUDENT_POPULATION']}>
          <div className="row small-gutters">
            {/* Visited */}
            <RenderSecure code="SUBJECT_COUNT">
              <div className="col-md-6 col-lg-6">
                <MetricCard 
                  iconClass="fa fa-book"
                  iconBg="bg-warning"
                  title="Subjects"
                  value= {subjectCount ? functions.numberFormat(subjectCount) : '...'}
                  trendText="Total Subjects"
                />
              </div>
            </RenderSecure>

            {/* Trainer */}
            <RenderSecure code="STUDENT_POPULATION">
              <div className="col-md-6 col-lg-6">
                <MetricCard 
                  iconClass="fa fa-graduation-cap"
                  iconBg="bg-danger"
                  title="Alumni Count"
                  value={alumniCount ? functions.numberFormat(alumniCount) : '...'}
                  trendText="Total Alumni"
                />
              </div>
            </RenderSecure>
          </div>
        </RenderSecure>
        </>
    );
};

export default MetricSection;